import MultilineText from "../../MultilineText"
import { Icon } from "../../ui/icons"

export default function ActionButton({
    action,
    context,
    onPress,
}) {
    const label = __.contextual(action.title_code, context)

    const tooltip = action.tooltip_code ? __.contextual(action.tooltip_code, context) : undefined

    const confirm = action.confirm_code ? __.contextual(action.confirm_code, context) : undefined

    const icon = action.icon ? <Icon type={action.icon} /> : undefined

    const handlePress = () => {
        if (action.disabled)
            return

        if (action.type !== 'document' && confirm) {
            onPress({
                confirm: true,
                confirmTitle: confirm
            })
        } else {
            onPress()
        }
    }

    switch (context) {
        case 'list': return <ButtonList action={action} title={label} icon={icon} tooltip={tooltip} onPress={handlePress} />
        default: return <ButtonDetail action={action} title={label} tooltip={tooltip} onPress={handlePress} />
    }
}

function ButtonList({action, title, icon, tooltip, onPress}) {

    const typeClassName = {
        document: 'button-border',
        accept: 'button-base',
        retry: 'button-white',
        cancel: ''
    }[action.type] || undefined

    if (action.type === 'document') {
        return (
            <a href={action.url} data-tooltip={tooltip} className={cn("button", typeClassName, action.disabled && 'disabled')} onClick={event => {
                event.preventDefault()
                onPress()
                return false
            }}>
                <MultilineText text={title} />
            </a>
        )
    }

    return <button disabled={action.disabled}
                   className={cn("button", typeClassName)}
                   onClick={onPress}
                   data-tooltip={tooltip}>
        {icon}
        <MultilineText text={title} />
    </button>
}

function ButtonDetail({action, title, tooltip, onPress}) {

    const typeClassName = {
        cancel: 'order-controlbtn__cancel'
    }[action.type] || undefined

    if (action.type === 'document') {
        return (
            <a href={action.url} className={cn('order-controlbtn', typeClassName, action.disabled && 'disabled')} data-tooltip={tooltip} onClick={event => {
                event.preventDefault()
                onPress()
                return false
            }}>
                <MultilineText text={title} />
            </a>
        )
    }

    return <a role='button'
              className={cn('order-controlbtn', typeClassName, action.disabled && 'disabled')}
              onClick={onPress}
              data-tooltip={tooltip}
    >
        <MultilineText text={title} />
    </a>
}
